import { useLazyQuery, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { API_REQUEST_TYPE } from '../../../pre-onboarding/data';
import { useDispatch } from 'react-redux';
import { GET_PREONBOARDING_STEP } from '../../constants/pre-onboarding/pre-onboarding';

const GET_INDUSTRY_AND_OCCUPATION_LIST_QUERY = gql`
    query GetIndustryAndOccupationList($requestFrom: String, $industryIds: [Int]) {
        getIndustryAndOccupationList(requestFrom: $requestFrom, industryIds: $industryIds) {
            success
            message
            data {
                occupations {
                    ocp_id
                    ocp_title
                    ocp_industry
                }
                industries {
                    inds_id
                    inds_title
                }
            }
        }
    }
`;

export const GetIndustryAndOccupationListAction = () => {
    const [queryFn, getIndustryAndOccupationListStatus] = useLazyQuery(
        GET_INDUSTRY_AND_OCCUPATION_LIST_QUERY,
        {
            fetchPolicy: 'cache-and-network',
            nextFetchPolicy: 'cache-and-network',
        }
    );

    const initGetIndustryAndOccupationList = (data, successCallBack, errorCallback) => {
        queryFn({
            variables: data,
        })
            .then((res) => {
                const resData = res.data.getIndustryAndOccupationList;
                if (resData.success) successCallBack && successCallBack(resData.data);
                else errorCallback && errorCallback(resData);
            })
            .catch((error) => {
                errorCallback && errorCallback(error);
            });
    };

    return { getIndustryAndOccupationListStatus, initGetIndustryAndOccupationList };
};

const SAVE_PREONBOARDING_DATA_MUTATION = gql`
    mutation SavePreOnBoardingData(
        $phoneCountry: String
        $phone: String
        $businessName: String
        $website: String
        $instagram: String
        $industryIds: [Int]
        $occupationIds: [Int]
        $selectedQuestionIds: [Int]
        $requestStepFrom: Int
        $isWebsiteAdded: Boolean
    ) {
        savePreOnBoardingData(
            phoneCountry: $phoneCountry
            phone: $phone
            businessName: $businessName
            website: $website
            instagram: $instagram
            industryIds: $industryIds
            occupationIds: $occupationIds
            selectedQuestionIds: $selectedQuestionIds
            requestStepFrom: $requestStepFrom
            isWebsiteAdded: $isWebsiteAdded
        ) {
            success
            message
        }
    }
`;

export const SavePreOnBoardingDataAction = () => {
    const [mutateFn, savePreOnBoardingDataStatus] = useMutation(SAVE_PREONBOARDING_DATA_MUTATION);

    const initSavePreOnBoardingData = (data, successCallback, errorCallback) => {
        mutateFn({
            variables: data,
        })
            .then((responseData) => {
                // console.log('savePreOnBoardingData--responseData', responseData)
                const resData = responseData.data.savePreOnBoardingData;
                if (resData.success) {
                    successCallback && successCallback(resData);
                } else {
                    errorCallback && errorCallback(resData);
                }
            })
            .catch((err) => {
                errorCallback && errorCallback(err);
            });
    };

    return { savePreOnBoardingDataStatus, initSavePreOnBoardingData };
};

const GET_PREONBOARDING_QUESTIONS_LIST_QUERY = gql`
    query GetPreOnBoardingQuestionsList($requestFrom: Int) {
        getPreOnBoardingQuestionsList(requestFrom: $requestFrom) {
            success
            message
            data {
                registerIntentionQuestionsStep3 {
                    reg_int_id
                    reg_int_title
                    iconUrl
                }
                teamSizeOptionQuestionsStep4 {
                    tso_id
                    tso_title
                    iconUrl
                }
            }
        }
    }
`;

export const GetPreOnBoardingQuestionsListAction = () => {
    const [queryFn, getPreOnBoardingQuestionsListStatus] = useLazyQuery(
        GET_PREONBOARDING_QUESTIONS_LIST_QUERY,
        {
            fetchPolicy: 'cache-and-network',
            nextFetchPolicy: 'cache-and-network',
        }
    );

    const initGetPreOnBoardingQuestionsList = (data, successCallBack, errorCallback) => {
        queryFn({
            variables: data,
        })
            .then((res) => {
                const resData = res.data.getPreOnBoardingQuestionsList;
                if (resData.success) successCallBack && successCallBack(resData.data);
                else errorCallback && errorCallback(resData);
            })
            .catch((error) => {
                errorCallback && errorCallback(error);
            });
    };

    return { getPreOnBoardingQuestionsListStatus, initGetPreOnBoardingQuestionsList };
};

const GET_PREONBOARDING_DATA_QUERY = gql`
    query GetPreOnBoardingData(
        $selectIndustryStep: Boolean!
        $businessDetailsStep: Boolean!
        $businessPurposeStep: Boolean!
        $businessSizeStep: Boolean!
    ) {
        getPreOnBoardingData {
            success
            message
            data {
                phoneCountry @include(if: $businessDetailsStep)
                phone @include(if: $businessDetailsStep)
                businessName @include(if: $businessDetailsStep)
                website @include(if: $businessDetailsStep)
                instagram @include(if: $businessDetailsStep)
                isWebsiteAdded @include(if: $businessDetailsStep)
                industryData @include(if: $selectIndustryStep) {
                    inds_id
                    inds_title
                }
                occupationData @include(if: $selectIndustryStep) {
                    ocp_id
                    ocp_title
                }
                step3 @include(if: $businessPurposeStep) {
                    reg_int_id
                    reg_int_title
                }
                step4 @include(if: $businessSizeStep) {
                    tso_id
                    tso_title
                }
            }
        }
    }
`;

export const GetPreOnBoardingDataAction = (step) => {
    const [queryFn, getPreOnBoardingDataStatus] = useLazyQuery(GET_PREONBOARDING_DATA_QUERY, {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-and-network',
    });

    const initGetPreOnBoardingData = (successCallBack, errorCallback) => {
        queryFn({
            variables: {
                selectIndustryStep: step === API_REQUEST_TYPE.step.selectIndustry,
                businessDetailsStep: step === API_REQUEST_TYPE.step.businessDetails,
                businessPurposeStep: step === API_REQUEST_TYPE.step.businessPurpose,
                businessSizeStep: step === API_REQUEST_TYPE.step.businessSize,
            },
        })
            .then((res) => {
                const resData = res.data.getPreOnBoardingData;
                if (resData.success) successCallBack && successCallBack(resData.data);
                else errorCallback && errorCallback(resData);
            })
            .catch((error) => {
                errorCallback && errorCallback(error);
            });
    };

    return { getPreOnBoardingDataStatus, initGetPreOnBoardingData };
};

const GET_PREONBOARDING_STEP_QUERY = gql`
    query GetPreOnBoardingStep {
        getPreOnBoardingStep {
            success
            message
            data {
                completedStep
            }
        }
    }
`;

export const GetPreOnBoardingStepAction = () => {
    const dispatch = useDispatch();
    const [queryFn, getPreOnBoardingStepStatus] = useLazyQuery(GET_PREONBOARDING_STEP_QUERY, {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-and-network',
    });

    const initGetPreOnBoardingStep = (successCallBack, errorCallback) => {
        queryFn()
            .then((res) => {
                const resData = res.data.getPreOnBoardingStep;
                console.log('resDataresData', resData);
                if (resData.success) {
                    dispatch({ type: GET_PREONBOARDING_STEP, payload: resData.data.completedStep });
                    successCallBack && successCallBack(resData.data);
                } else errorCallback && errorCallback(resData);
            })
            .catch((error) => {
                errorCallback && errorCallback(error);
            });
    };

    return { getPreOnBoardingStepStatus, initGetPreOnBoardingStep };
};
